module.exports = __webpack_public_path__ + "static/img/banner31.4c2c2aca.jpg";